module.exports = __webpack_public_path__ + "static/media/Background4.4321b4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Backgrounds/Background4.png
// module id = 255
// module chunks = 0